import { render } from "./StaticContent.vue?vue&type=template&id=44a6aa58"
import script from "./StaticContent.vue?vue&type=script&lang=js"
export * from "./StaticContent.vue?vue&type=script&lang=js"

import "./StaticContent.vue?vue&type=style&index=0&id=44a6aa58&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__